import { AuthService } from "./auth-service";

const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require("axios").default;

export class AdvBannerService {

  static async getList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/advbanners/`;
      const response = await axios.get(base_url, {
        params: params,
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response;
      //throw error;
    }
  }

  static async getSingle(id) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/advbanners/`
      const response = await axios.get(`${base_url}${id}`, {
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      // console.log(response);
      return response;
    } catch (error) {
      return error.response;
    }
  }

}
